import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import * as cashierActions from '../../../source/appstates/cashierstates/cashierActions'
import * as loginActions from '../../../source/appstates/loginstates/loginActions'
import * as playerActions from '../../../source/appstates/playerstates/playerActions'
import * as appState from '../../../source/appstates/appState'
import { PlaceholderDirective } from '../../PlaceholderDirective';
import { GetDocumetsResponse } from '../../../source/modules/player/getDocument';
import { UploadFileResponse } from '../../../source/modules/player/uploadfileresponse';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Profile } from '../../../source/modules/player/profile';
import { PlayerLevelResponse } from '../../../source/modules/player/playerLevel';
import { Ticket, WalletInfo } from '../../../source/modules/cashier/balance';
import { Store } from '@ngrx/store';
import { Router, RouterLink } from '@angular/router';
import { UploadServiceService } from '../../../source/services/uploadDocuments/upload-service.service';
import { PlayerGetProfile } from '../../../source/appstates/playerstates/playerActions';
import { LoginState } from '../../../source/appstates/loginstates/loginState';
import { ProfileState } from '../../../source/appstates/playerstates/playerState';
import { UpdatePorfileComponent } from '../update-porfile/update-porfile.component';
import { AccountDetailsComponent } from '../account-details/account-details.component';
import { CommonModule } from '@angular/common';

import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../../source/services/login/login.service';

declare var $: any;


@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit, OnDestroy {
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  tickets = ['1', '2']
  doctype: any;
  pandoctype: boolean = false;
  idproof: boolean = false;
  adressproof: boolean = false;
  UploadFileResponse!: UploadFileResponse;
  GetDocumetsResponse!: GetDocumetsResponse;
  form!: FormGroup;
  updatePassword!: FormGroup;
  uploadFile!: FormGroup;
  imagepath!: File[];
  private storeSub!: Subscription;
  private storeCashierSub!: Subscription;
  private closeSub!: Subscription;
  profile!: Profile;
  PlayerLevelResponse!: PlayerLevelResponse[];
  edit: boolean = false;
  editPassword: boolean = false;
  documentsstatus: any;
  pancardstatus: any;
  idproofstatus: any;
  adressproofstatus: any;
  walleteInfo!: WalletInfo[];
  tikets: any;
  percentDone: any;
  uploadSuccess: any;
  errormessage: any;
  loginSub: Subscription;
  fileToUpload!: any;
  showCopiedMessage = false;
  friendREF: any;
  playerLoggedIn: boolean = false;

  showPhonePopup = false;

  newPhone = '';

  otpSent = false;
  otpVerified = false;
  otpError = false;

  enteredOtp = '';

  countdown = 0;
  timer: any;

  isSendingOtp = false;
  isVerifyingOtp = false;
  isUpdatingPhone = false;
  errorMessage: any;
  loader_up: boolean = false;
  mobileValueStatus:boolean = true
  constructor(private formBuilder: FormBuilder, private store: Store<appState.AppState>,
    private router: Router, private translate: TranslateService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private UploadService: UploadServiceService,
    private meta: Meta, private title: Title,
    private loginService: LoginService) {

    this.store.dispatch(new PlayerGetProfile());

    this.store.dispatch(new cashierActions.CashierGetBalanceStart());
    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
        }
        if (!this.playerLoggedIn) {
          this.router.navigate(["/home"]);
        }
      });
  }

  ngOnInit() {
    this.friendREF = (localStorage.getItem('friendRF'))
    console.log(typeof this.friendREF)
    this.getDocuments();



    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
          if (this.playerLoggedIn) {
            this.store.dispatch(new cashierActions.CashierGetBalanceStart());
          }
          if (!this.playerLoggedIn) {
            this.router.navigate(["/home"]);
          }
        }
      });
    this.form = new FormGroup({
      "nickname": new FormControl('', Validators.required),
      "email": new FormControl(null, [Validators.required, Validators.email]),
      "firstName": new FormControl('', Validators.required),
      "lastName": new FormControl('', Validators.required),
      "address": new FormGroup({
        "city": new FormControl('', Validators.required),
        "phone": new FormControl('', Validators.required),
        "country": new FormControl('', Validators.required),
      }),
    })

    this.uploadFile = new FormGroup({
      file: new FormControl(null),
      docType: new FormControl(1),
    })

    this.updatePassword = new FormGroup({
      "oldPassword": new FormControl('', Validators.required),
      "newPassword": new FormControl('', Validators.required)
    })

    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {


        if (playerState.profile) {
          this.profile = playerState.profile;
          if (this.profile) {
            if (this.profile.nickname) {
              const nicknameControl = <FormControl>this.form.get('nickname');
              if (nicknameControl) {
                nicknameControl.setValue(this.profile.nickname);
              }
            }
            if (this.profile.email) {
              const emailControl = <FormControl>this.form.get('email');
              if (emailControl) {
                emailControl.setValue(this.profile.email);
              }
            }
            if (this.profile.firstName) {
              const firstNameControl = <FormControl>this.form.get('firstName');
              if (firstNameControl) {
                firstNameControl.setValue(this.profile.firstName);
              }
            }
            if (this.profile.lastName) {
              const lastNameControl = <FormControl>this.form.get('lastName');
              if (lastNameControl) {
                lastNameControl.setValue(this.profile.lastName);
              }
            }
            if (this.profile.pixelURL) {
              const pixelURLControl = <FormControl>this.form.get('pixelURL');
              if (pixelURLControl) {
                pixelURLControl.setValue(this.profile.pixelURL);
              }
            }
            if (this.profile.address) {
              let addressFormGroup = <FormGroup>this.form.get('address');
              if (!addressFormGroup) {
                addressFormGroup = new FormGroup({
                  city: new FormControl(''),
                  phone: new FormControl(''),
                  country: new FormControl('')
                });
                // Add the address form group back to the form
                this.form.addControl('address', addressFormGroup);
              }

              if (this.profile?.address?.city) {
                addressFormGroup.get('city')?.setValue(this.profile.address.city);
              }

              if (this.profile?.address?.phone) {
                addressFormGroup.get('phone')?.setValue(this.profile.address.phone);
                this.mobileValueStatus = false
              }

              if (this.profile?.address?.country) {
                addressFormGroup.get('country')?.setValue(this.profile.address.country);
              }
            }
          }

        }
        if (playerState.playerLevel) {
          this.PlayerLevelResponse = playerState.playerLevel.playerLevelResponses;
        }

      }
    )
    this.store.dispatch(new playerActions.PlayerGetProfile());
    // const title = 'Your Profile - Manage Your Account at Gambaji'; 
    // const discript = "Access and manage your profile on Gambaji. View your gaming history, account details, and personal settings for a personalized experience.";
    this.translate.get('PROFILE_TITLE').subscribe(res => {
      this.title.setTitle(res);
      this.meta.updateTag({ property: 'og:description', content: res });
    });

    this.translate.get('PROFILE_DESCRIPTION').subscribe(res => {
      this.meta.updateTag({ name: 'description', content: res });
    });

    const url = 'https://gambaji.com' + this.router.url;
    this.meta.updateTag({ property: 'og:url', content: url });



    console.log(this.profile?.address?.phone)
  };


  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    if (this.storeCashierSub) {
      this.storeCashierSub.unsubscribe();
    }
    if (this.closeSub) {
      this.closeSub.unsubscribe();
    }
    if (this.profile) {
      this.profile = this.profile;
    }
  };

  showUpdateProfile(value: string) {

    if (this.alertHost) {
      const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(UpdatePorfileComponent);
      const hostViewContainerRef = this.alertHost;
      hostViewContainerRef.clear();

      const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
      componentRef.instance.fromProfileState = value;
      if (this.closeSub) {
        this.closeSub.unsubscribe();
      }

      this.closeSub = componentRef.instance.close.subscribe(() => {
        hostViewContainerRef.clear();
      });
    }
  }

  editProfile() {
    this.edit = this.edit ? false : true;
  }
  changePassword() {
    this.editPassword = this.editPassword ? false : true;
  }
  onFormSubmit() {
    this.store.dispatch(new playerActions.PlayerUpdateProfile(this.form.value));
  }
  onUpdatePasswordSubmit() {
    this.store.dispatch(new playerActions.PlayerUpdatePassword(this.updatePassword.value));
  }


  handleFilePanCard(files: FileList) {
    this.doctype = 3;
    this.fileToUpload = files.item(0);
    this.UploadService.postFile(this.fileToUpload, this.doctype).subscribe(data => this.uploadFileResponsedata(data));
  }

  handleFileIdCard(files: FileList) {
    this.doctype = 1;
    this.fileToUpload = files.item(0);
    this.UploadService.postFile(this.fileToUpload, this.doctype).subscribe(data => this.uploadFileResponsedata(data));
  }

  handleFileAddress(files: FileList) {
    this.doctype = 2;
    this.fileToUpload = files.item(0);
    this.UploadService.postFile(this.fileToUpload, this.doctype).subscribe(data => this.uploadFileResponsedata(data));
  }
  // uploadFileToActivity() {

  // }
  uploadFileResponsedata(data: any) {
    this.UploadFileResponse = data;
    if (this.UploadFileResponse.success == true) {
      this.getDocuments();
    } else if (this.UploadFileResponse.success == false) {
      this.errormessage = this.UploadFileResponse.success;
    }
  }

  getDocuments() {
    this.UploadService.getDocumetsfile().subscribe(data => this.getDocumentsResponse(data));
  }

  getDocumentsResponse(data: any) {
    this.GetDocumetsResponse = data;
    if (this.GetDocumetsResponse.success == true) {
      this.documentsstatus = this.GetDocumetsResponse.documents;
      for (let docdata of this.documentsstatus) {
        if (docdata.docType == 'Pan Card') {
          this.pandoctype = true;
          this.pancardstatus = this.GetDocumetsResponse.documents;
        } else {
        }
      }
      for (let docdata of this.documentsstatus) {
        if (docdata.docType == 'Address Proof') {
          this.adressproof = true;
          this.adressproofstatus = this.GetDocumetsResponse.documents;
        } else {
        }
      }
      for (let docdata of this.documentsstatus) {
        if (docdata.docType == 'Id Proof') {
          this.idproof = true;
          this.idproofstatus = this.GetDocumetsResponse.documents;
        } else {

        }
      }
    } else if (this.GetDocumetsResponse.success == false) {

    }
  }
  copyMessage(val: string) {
    // console.log(val)
    // if (val) {
    //   navigator.clipboard.writeText(val) 
    // }
    console.log(val)
    const tempTextarea = document.createElement('textarea');
    tempTextarea.value = val;
    console.log(tempTextarea)
    document.body.appendChild(tempTextarea);

    // Select the text inside the textarea
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, tempTextarea.value.length);  // For mobile devices

    try {
      // Execute the copy command
      const successful = document.execCommand('copy');
      if (successful) {
        console.log('Text copied successfully');
        this.showCopiedMessage = true;
        setTimeout(() => {
          this.showCopiedMessage = false;
        }, 2000);
      } else {
        console.error('Failed to copy text');
      }
    } catch (err) {
      console.error('Error copying text: ', err);
    }

    // Remove the temporary textarea element
    document.body.removeChild(tempTextarea);

  }

  showUpdatePhonePopup() {
    this.showPhonePopup = true;

    this.newPhone = '';
    this.enteredOtp = '';

    this.otpSent = false;
    this.otpVerified = false;
    this.otpError = false;
  }

  sendPhoneOtp() {
    this.loader_up = true
    this.errorMessage = ''

    this.isSendingOtp = true;

    const body = {
      face: 'bdtmaster',
      ip: '',
      language: 'en',
      mobile: this.newPhone,
      // password: ''
    };

    this.loginService.onRegisterGenarateOTPStart(body)
      .subscribe({
        next: (res: any) => {
          this.loader_up = false;

          this.isSendingOtp = false;

          if (res.success) {

            this.otpSent = true;
            this.startTimer();

          } else {
            // this.errorMessage = res.description || 'Failed';
            if (res.description == "DUPLICATE_MOBILE") {
              this.errorMessage = "Mobile number already exists or invalid"
              
            } else if (res.description == "INVALID_INPUT_DATA") {
              this.errorMessage = "Invalid input data"
            }
            else {
              // this.errorMessage = data.description
              this.errorMessage = res.description || 'Failed to send OTP';
            }
            
            setTimeout(() => {
              // this.newPhone = ''
              this.errorMessage = ''
            }, 3000)

          }

        },
        error: () => {
          this.loader_up = false
          this.isSendingOtp = false;
        }
      });
  }
  resendPhoneOtp() {

    this.otpSent = false;
    this.enteredOtp = '';
    this.otpError = false;

    this.sendPhoneOtp();
  }


  verifyPhoneOtp() {

    this.isVerifyingOtp = true;
    this.loader_up = true

    const body = {
      otp: this.enteredOtp,
      mobile: this.newPhone
    };

    this.loginService
      .validateOTP(body)
      .subscribe({
        next: (res: any) => {
          this.loader_up = false;

          this.isVerifyingOtp = false;

          if (res.success) {

            this.otpVerified = true;
            this.otpError = false;

            clearInterval(this.timer);

            this.updatePhoneNumber()

          } else {

            this.otpError = true;
            this.otpVerified = false;

          }

        },
        error: () => {
          this.loader_up = false;
          this.isVerifyingOtp = false;
          this.otpError = true;

        }
      });
  }
  updatePhoneNumber() {
    this.loader_up = true;

    this.isUpdatingPhone = true;

    const body = {
      phone: this.newPhone
    };

    this.store.dispatch(
      new playerActions.PlayerUpdateProfile({
        ...this.form.value,
        address: {
          ...this.form.value.address,
          phone: this.newPhone
        }
      })
    );

    setTimeout(() => {

      this.isUpdatingPhone = false;
      this.showPhonePopup = false;

      this.store.dispatch(
        new playerActions.PlayerGetProfile()
      );
      this.loader_up = false
    }, 1000);

  }

  startTimer() {

    clearInterval(this.timer);

    this.countdown = 60;

    this.timer = setInterval(() => {

      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }

    }, 1000);
  }
  closePhonePopup() {

    this.showPhonePopup = false;

    this.newPhone = '';
    this.enteredOtp = '';

    this.otpSent = false;
    this.otpVerified = false;
    this.otpError = false;

    this.isSendingOtp = false;
    this.isVerifyingOtp = false;

    clearInterval(this.timer);
    this.countdown = 0;
  }

  allowNumbersOnly(event: KeyboardEvent): boolean {
  const charCode = event.which ? event.which : event.keyCode;

  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }

  return true;
}
}
